import React from "react";
import { Route } from "react-router-dom";
import { WixPriceDialog } from "./price-dialog/WixPriceDeleteDialog";
import CartPriceCard from "./WixPrice";
import { WixPriceUIProvider } from "./WixPriceUIContext";

export function WixPricePage({ history }) {
  
  const priceUIEvents = {
    newPriceButtonClick: () => {
      history.push(`/app/wix-price/new`);
    },
    openEditPricePage: (id) => {
      history.push(`/app/wix-price/${id}/edit`);
    },
    openDeletePriceDialog: (id) => {
      history.push(`/wix-price/${id}/delete`);
    },
  };

  return (
    <WixPriceUIProvider priceUIEvents={priceUIEvents}>
      <Route exact path={`/wix-price/:id/delete`}>
        {({ history, match }) => {
          return (
            <WixPriceDialog
              show={match != null}
              id={match && match.params.id}
              onHide={() => {
                history.push(`/wix-price`);
              }}
            />
          );
        }}
      </Route>
      <CartPriceCard />
    </WixPriceUIProvider>
  );
}
